import * as React from "react";
import { connect } from "react-redux";
import * as ReactDOM from "react-dom";

import { RootState, Dispatch } from "../../../store/types";
import { Product } from "../../../models";
import { MetaTags } from "../../../head";
import {
  CustomScrollbar,
  ProductDisplay,
  LoadingSpinner,
} from "../../../components";
import * as selectors from "../selectors";
import * as actions from "../actions";

import "./SelectedProduct.css";

interface SelectedProproductProps {
  product?: Product;
  match?: any;
  fetchProduct: (id: number | string) => void;
}

interface SelectedProductState {
  height: number;
}

class SelectedProduct extends React.Component<
  SelectedProproductProps,
  SelectedProductState
> {
  public state: SelectedProductState = {
    height: 0,
  };

  public componentDidMount() {
    const rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
    const height = window.innerHeight - rect.top - 100; // footer height = 100
    this.setState({ height });

    const { productId } = this.props.match.params;

    // Fetch product if not already in state or route param doesn't match current state
    if (this.props.product == null || this.props.product.id !== productId) {
      this.props.fetchProduct(productId);
    }
  }

  private renderMeta() {
    const product = this.props.product as Product;
    const {
      display_price,
      display_dimension,
      display_time,
      display_consultant,
      display_deliverable,
    } = product;

    const description = `Báo giá: ${display_price}.
      Kích thước: ${display_dimension}.
      Thời gian ước tính: ${display_time}.
      Tư vấn: ${display_consultant}.
      Sản phẩm: ${display_deliverable}`;

    return (
      <MetaTags
        key={0}
        title={product.name}
        description={description}
        image={product.image}
        ogType="product.item"
      >
        <meta
          property="product:retailer_item_id"
          content={product.id.toString()}
        />
        <meta
          property="product:retailer_group_id"
          content={product.category_id.toString()}
        />

        <meta property="product:price:amount" content={product.display_price} />
        <meta property="product:price:currency" content="vnd" />
        <meta property="product:brand" content="Express Design" />
      </MetaTags>
    );
  }

  private renderProduct = () =>
    !this.props.product ? (
      <LoadingSpinner large />
    ) : (
      [this.renderMeta(), <ProductDisplay key={1} {...this.props.product} />]
    );

  public render() {
    return (
      <div className="selected-product">
        <CustomScrollbar maxHeight={this.state.height}>
          {this.renderProduct()}
        </CustomScrollbar>
      </div>
    );
  }
}

const mapStateToProps = (
  state: RootState,
): Partial<SelectedProproductProps> => ({
  product: selectors.chosenProduct(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<SelectedProproductProps> => ({
  fetchProduct: (id: number | string) =>
    dispatch(actions.chooseProductById(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectedProduct);



// WEBPACK FOOTER //
// ./src/routes/Step1/components/SelectedProduct.tsx